export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9322.12a1b607.jpg";